module.exports = __webpack_public_path__ + "static/media/partner3.388883d7.png";